export default __webpack_public_path__ + "static/media/home-furniture-shop-slider-img-02.b4bc519b.png";